document.addEventListener('DOMContentLoaded', function() {
  // Sort functionality
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // View toggle functionality
  var viewBtns = document.querySelectorAll('.collection__view-btn');
  var productGrid = document.querySelector('.product-grid');
  var mobileBreakpoint = 768;

  function switchToGridView() {
    if (productGrid) {
      productGrid.classList.remove('product-grid--list');
    }
    viewBtns.forEach(function(b) { b.classList.remove('collection__view-btn--active'); });
    var gridBtn = document.querySelector('[data-view="grid"]');
    if (gridBtn) {
      gridBtn.classList.add('collection__view-btn--active');
    }
  }

  function isMobile() {
    return window.innerWidth < mobileBreakpoint;
  }

  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var view = this.getAttribute('data-view');

      // Update active button
      viewBtns.forEach(function(b) { b.classList.remove('collection__view-btn--active'); });
      this.classList.add('collection__view-btn--active');

      // Update grid class
      if (view === 'list') {
        productGrid.classList.add('product-grid--list');
      } else {
        productGrid.classList.remove('product-grid--list');
      }

      // Save preference
      localStorage.setItem('collectionView', view);
    });
  });

  // Switch to grid view on mobile resize
  window.addEventListener('resize', function() {
    if (isMobile() && productGrid && productGrid.classList.contains('product-grid--list')) {
      switchToGridView();
    }
  });

  // Restore saved view preference (only on desktop)
  var savedView = localStorage.getItem('collectionView');
  if (savedView === 'list' && !isMobile()) {
    var listBtn = document.querySelector('[data-view="list"]');
    if (listBtn) listBtn.click();
  }
});
